export function GetMockLookupList() {
  return [
    {
      id: 1,
      lookupTypeId: 1,
      description: "Proceedable",
      order: 0,
    },
    {
      id: 2,
      lookupTypeId: 1,
      description: "Not Proceedable",
      order: 0,
    },
  ];
}
